import React, { memo } from 'react';
import { DetailsFormSection } from '@/components';
import { CreateEventFormData, CreateEventFormErrors } from '@/types/admin/createEvent';

interface EventDetailsSectionProps {
  formData: CreateEventFormData;
  errors: CreateEventFormErrors;
  onFieldChange: (field: keyof CreateEventFormData, value: string | Date) => void;
}

const eventFields = [
  {
    key: 'name',
    label: 'Event Name',
    placeholder: 'Enter event name',
    required: true,
    autoCapitalize: 'sentences' as const,
  },
  {
    key: 'description',
    label: 'Description',
    placeholder: 'Describe your event',
    required: true,
    multiline: true,
    numberOfLines: 4,
    autoCapitalize: 'sentences' as const,
  },
  {
    key: 'location',
    label: 'Location',
    placeholder: 'Event location',
    required: true,
    autoCapitalize: 'words' as const,
  },
];

export const EventDetailsSection = memo<EventDetailsSectionProps>(({
  formData,
  errors,
  onFieldChange,
}) => {
  return (
    <DetailsFormSection
      title="Event Details"
      formData={formData}
      errors={errors}
      onFieldChange={onFieldChange}
      fields={eventFields}
    />
  );
});

EventDetailsSection.displayName = 'EventDetailsSection';
